import { DEPOSITS } from './definitions.js'

const STORAGE_KEY = 'lazyminer.autosave'
const SAVE_VERSION = 3
const COMPATIBLE_SAVE_VERSIONS = new Set([1, 2, SAVE_VERSION])

export default class SaveSystem
{
    constructor(_state)
    {
        this.state = _state
        this.interval = window.setInterval(() => this.save(), 2000)
        window.addEventListener('pagehide', () => this.save())
        document.addEventListener('visibilitychange', () =>
        {
            if(document.visibilityState === 'hidden')
                this.save()
        })
        this.save()
    }

    static load()
    {
        try
        {
            const raw = window.localStorage.getItem(STORAGE_KEY)
            if(!raw)
                return null
            const save = JSON.parse(raw)
            if(!COMPATIBLE_SAVE_VERSIONS.has(save.version) || !save.state || typeof save.state !== 'object')
                return null
            if(save.version < 3)
            {
                for(const deposit of DEPOSITS)
                {
                    const savedDeposit = save.state.deposits?.[deposit.id]
                    if(deposit.tree || !savedDeposit || !Number.isFinite(savedDeposit.remaining))
                        continue
                    const previousAmount = deposit.amount / 10
                    savedDeposit.remaining = Math.min(deposit.amount, savedDeposit.remaining + deposit.amount - previousAmount)
                }
            }
            return save.state
        }
        catch
        {
            return null
        }
    }

    static clear()
    {
        try
        {
            window.localStorage.removeItem(STORAGE_KEY)
        }
        catch
        {
        }
    }

    clear()
    {
        this.stopped = true
        window.clearInterval(this.interval)
        SaveSystem.clear()
    }

    save()
    {
        if(this.stopped)
            return false
        try
        {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
                version: SAVE_VERSION,
                savedAt: Date.now(),
                state: this.state.toJSON()
            }))
            return true
        }
        catch
        {
            return false
        }
    }
}
